import type { MeldErnst, MeldSoort } from './types';

/**
 * P5: the unsent form is kept in this browser, so closing the panel by
 * accident loses nothing. Never the screenshot: that would be customer data
 * lying around in localStorage. Storage may be blocked (private mode); then
 * the concept simply is not kept.
 */
export interface MeldConcept { titel: string; omschrijving: string; soort: MeldSoort; ernst: MeldErnst }

export const LEEG_CONCEPT: MeldConcept = { titel: '', omschrijving: '', soort: 'probleem', ernst: 'hindert' };

const SLEUTEL = 'priceq.meldconcept';
const SOORTEN: readonly string[] = ['probleem', 'idee', 'vraag'];
const ERNSTEN: readonly string[] = ['blokkeert', 'hindert', 'klein'];

function isConcept(d: unknown): d is MeldConcept {
  if (typeof d !== 'object' || d === null) return false;
  const c = d as Record<string, unknown>;
  return typeof c.titel === 'string' && typeof c.omschrijving === 'string'
    && typeof c.soort === 'string' && SOORTEN.includes(c.soort)
    && typeof c.ernst === 'string' && ERNSTEN.includes(c.ernst);
}

export function leesConcept(): MeldConcept {
  try {
    const ruw = localStorage.getItem(SLEUTEL);
    if (!ruw) return LEEG_CONCEPT;
    const d: unknown = JSON.parse(ruw);
    return isConcept(d) ? d : LEEG_CONCEPT;
  } catch {
    return LEEG_CONCEPT;
  }
}

export function bewaarConcept(c: MeldConcept): void {
  try {
    localStorage.setItem(SLEUTEL, JSON.stringify(c));
  } catch {
    /* private mode: no concept, nothing else changes */
  }
}

export function wisConcept(): void {
  try {
    localStorage.removeItem(SLEUTEL);
  } catch {
    /* private mode */
  }
}
